module.exports = __webpack_public_path__ + "static/media/Sena.5fe217ea.png";